import React, { forwardRef } from 'react';
import Type from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { isExternalUrl } from 'utils/string';
import LinkWithRetainedParams from '../LinkWithRetainedParams';
import ExternalLink from '../ExternalLink';

/**
 * Link that also works for external URL's
 */
const Link = forwardRef((props, ref) => {
  const { to, children, urlUpdateType, ...other } = props;

  const renderExternalLink = () => (
    <ExternalLink to={to} {...other} ref={ref}>
      {children}
    </ExternalLink>
  );

  const renderInnerLink = () => {
    switch (urlUpdateType) {
      case 'replace':
        return (
          <RouterLink to={to} {...other} ref={ref}>
            {children}
          </RouterLink>
        );

      case 'pushIn':
        return (
          <LinkWithRetainedParams to={to} {...other} ref={ref}>
            {children}
          </LinkWithRetainedParams>
        );

      default:
        return null;
    }
  };

  return isExternalUrl(to) ? renderExternalLink() : renderInnerLink();
});

Link.propTypes = {
  to: Type.oneOfType([Type.string, Type.object, Type.func]).isRequired,
  urlUpdateType: Type.oneOf(['pushIn', 'replace']),
  children: Type.node.isRequired,
};

Link.defaultProps = {
  urlUpdateType: 'replace',
};

export default Link;
